import Axios from "axios";
import { BaseService } from "./BaseService";
import { Usuario, ResponsableFiltro, UsuarioBorrarCuenta, UsuarioPerfil } from "@/model/Usuario";

BaseService.loadAxios();

const RESOURCE_NAME = "Responsable";

export class UsuarioService {
   /* public static async getUsuariosAsync(usuario?: string, documento?: string, nombre?: string, id_empresa?: number, email?: string) {        
        return await Axios.get(RESOURCE_NAME + `?usuario=${usuario || ""}&documento=${documento || ""}&nombre=${nombre || ""}&id_empresa=${id_empresa || ""}&email=${email || ""}`);
    }
    */
    public static async getUsuariosAsync(filtro: ResponsableFiltro) {        
        return await Axios.post(RESOURCE_NAME + '/usuarios', filtro);
    }
    
    public static async getUsuarioByIdAsync(id: string) {        
        return await Axios.get(RESOURCE_NAME + `/${id}`);
    }

    public static async getEmpresasUsuarioAsync() {        
        return await Axios.get(RESOURCE_NAME + '/empresas/usuario');
    }
    
    public static async getPerfilesUsuarioAsync() {        
        return await Axios.get(RESOURCE_NAME + '/perfiles/usuario');
    }

    public static async grabarUsuarioAsync(usuario: Usuario) {
        return await Axios.post(RESOURCE_NAME, usuario);
    }

    public static async actualizarUsuarioAsync(usuario: Usuario) {
        return await Axios.put(RESOURCE_NAME, usuario);
    }

    public static async quitarUsuario(id: number) {
        return await Axios.delete(`${RESOURCE_NAME}/${id}`);
    }
        
    public static async perfilDefecto(id: string) {
        return await Axios.put(`${RESOURCE_NAME}/perfilDefecto/${id}`);
    }
    
    public static async ejercicioDefecto(id: string) {
        return await Axios.put(`${RESOURCE_NAME}/ejercicioDefecto/${id}`);
    }

    public static async borrarCuentaAsync(item: UsuarioBorrarCuenta) {
        return await Axios.put(`${RESOURCE_NAME}/borrar/cuenta`, item);
    }

    //#region "Usuarios de un Perfil"
    
    public static async getUsuariosPerfilAsync(id: string) {        
        return await Axios.get(RESOURCE_NAME + '/usuarios/perfil'+ `/${id}`);
    }    
    public static async asignarUsuariosPerfilAsync(item: UsuarioPerfil){
        return await Axios.post(RESOURCE_NAME + "/asignar/usuarios/perfil", item);
    }
    
    //#endregion

}